import { createContext, useContext, useState, ReactNode } from 'react';

// Define the edit mode context type
export interface EditModeContextType {
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
}

// Create the context with default values
export const EditModeContext = createContext<EditModeContextType>({
  isEditMode: true,
  setIsEditMode: () => {}
});

// Provider component to manage edit mode state
export function EditModeProvider({ 
  children, 
  defaultEditMode = true 
}: { 
  children: ReactNode; 
  defaultEditMode?: boolean;
}) {
  const [isEditMode, setIsEditMode] = useState(defaultEditMode);
  
  return (
    <EditModeContext.Provider value={{ isEditMode, setIsEditMode }}>
      {children}
    </EditModeContext.Provider>
  );
}

// Custom hook to access the edit mode context
export const useEditMode = () => useContext(EditModeContext); 
